export default {
  translation: {
    regionPicker: {
      chooseArea: 'Scegli il tuo Paese'
    },
    configurator: {
      configureNow: 'Configura la mia maniglia!',
      chooseFrameColor: 'Scegli il color della finestra',
      chooseHandle: 'Scegli il modello di maniglia da configurare',
      createYourOwnButton: 'Crea la mia maniglia personalizzata',
      createYourOwn: 'Carica il file',
      sendConfig: 'Salva questa maniglia',
      colorType: {
        ral: 'Verniciata',
        anodized: 'Anodizzata',
        decor: 'Decorata',
        custom: 'Personalizzata'
      },
      color: {
        black: 'Nero',
        white: 'Bianco'
      },
      form: {
        myConfig: 'Salva la mia maniglia personalizzata',
        send: 'Invia!',
        success: 'La tua configurazione è stata inviata via email con successo!',
        error: 'Attenzione! L\'invio dell\'email non è andato a buon fine!',
        model: 'Codice maniglia',
        color: 'Colore',
        ornament: 'Decoro',
        ornament_color: 'Colore del decoro',
        custom: 'Immagine personalizzata'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/i18n/it.js